// Determine metric category for chart color - EXACT copy from original
export const getMetricCategory = (label) => {
  const lowerLabel = label.toLowerCase();
  if (lowerLabel.includes('imminent') || lowerLabel.includes('suicide') || lowerLabel.includes('safety')) {
    return { name: 'Critical Risk', color: '#e74c3c' };
  } else if (lowerLabel.includes('risk') || lowerLabel.includes('depression') || lowerLabel.includes('anxiety')) {
    return { name: 'High Risk', color: '#f39c12' };
  } else if (lowerLabel.includes('help') || lowerLabel.includes('requested') || lowerLabel.includes('seeking')) {
    return { name: 'Help Requested', color: '#27ae60' };
  }
  return { name: 'Monitor', color: '#3498db' };
};

// Prepare chart data based on mode - EXACT copy from original
export const prepareChartData = (metric, isComparisonMode, totalPopulation = 174) => {
  const category = getMetricCategory(metric.label);

  let chartData;
  let baselineCount, followupCount;

  if (isComparisonMode) {
    // In comparison mode, create baseline vs follow-up data
    baselineCount = metric.baselineCount; // Mock baseline data
    followupCount = metric.followupCount; // Current data as follow-up

    chartData = [
      {
        name: 'Baseline',
        value: baselineCount,
        percent: metric.baselinePercent,
        color: category.color,
        opacity: 0.6
      },
      {
        name: 'Follow-up',
        value: followupCount,
        percent: metric.followupPercent,
        color: category.color,
        opacity: 1
      }
    ];
  } else {
    // Normal mode - show metric vs other patients
    // Calculate total population from metric data
    const calculatedTotal = Math.round((metric.count * 100) / metric.percent);
    const remainingPatients = calculatedTotal - metric.count;

    chartData = [
      {
        name: metric.label,
        value: metric.count,
        percent: metric.percent,
        color: category.color
      },
      {
        name: 'Other Patients',
        value: remainingPatients,
        percent: Math.round((remainingPatients / calculatedTotal) * 100),
        color: '#E5E7EB'
      }
    ];
  }

  return { chartData, baselineCount, followupCount };
};
